import Vue from 'vue'

const state = Vue.observable({
  tabs: [],
  activeTab: null
})

export function useTabs() {
  const addTab = (tab) => {
    const existingTab = state.tabs.find(t => t.path === tab.path)
    if (!existingTab) {
      if (tab.path === '/workbench') {
        const workbenchIndex = state.tabs.findIndex(t => t.path === '/workbench')
        if (workbenchIndex === -1) {
          state.tabs.unshift({
            path: tab.path,
            title: tab.title,
            name: tab.name || tab.title,
            active: false
          })
        }
      } else {
        state.tabs.push({
          path: tab.path,
          title: tab.title,
          name: tab.name || tab.title,
          active: false
        })
      }
    }
    state.activeTab = tab.path
  }

  const removeTab = (path) => {
    const index = state.tabs.findIndex(t => t.path === path)
    if (index > -1 && path !== '/workbench') {
      state.tabs.splice(index, 1)
      if (state.activeTab === path) {
        const lastTab = state.tabs[state.tabs.length - 1]
        state.activeTab = lastTab ? lastTab.path : null
      }
    }
  }

  const setActiveTab = (path) => {
    state.activeTab = path
  }

  const refreshTab = (path) => {
    const tab = state.tabs.find(t => t.path === path)
    if (tab) {
      tab.refreshKey = Date.now()
    }
  }

  const clearTabs = () => {
    state.tabs = []
    state.activeTab = null
  }

  const isActive = (path) => {
    return state.activeTab === path
  }

  const currentTab = () => {
    return state.tabs.find(t => t.path === state.activeTab)
  }

  return {
    tabs: state.tabs,
    activeTab: state.activeTab,
    addTab,
    removeTab,
    setActiveTab,
    refreshTab,
    clearTabs,
    isActive,
    currentTab
  }
}

export default {
  install(Vue) {
    Vue.mixin({
      created() {
        this.$tabs = useTabs()
      }
    })
  }
}
